<template>
  <pt-detection-corpus-structure-list class="pt-detection-corpus-structure-list__page"></pt-detection-corpus-structure-list>
</template>

<script>
import PtDetectionCorpusStructureList from 'cps/gene-product/pt-detection-corpus-structure-list/withData'
export default {
  name: 'pt-detection-corpus-structure-list__view',
  components: {
    'pt-detection-corpus-structure-list': PtDetectionCorpusStructureList
  }
}
</script>
